import { jsx as _jsx } from "react/jsx-runtime";
import { handleLeadingZero } from "./utils";
import { Button } from "../button";
export function Chip({ onClick, scrollBarIndex, unit, text, value, }) {
    return (_jsx(Button, Object.assign({ "data-chip-value": handleLeadingZero(value), onClick: onClick, stylingType: "flat" }, { children: handleLeadingZero(text) }), `${unit}-${scrollBarIndex}-${handleLeadingZero(value)}`));
}
